import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const ConsignmentAssignedVehicleDefinitionList = ({ consignment, vehicle }) => {
    const isContracted = vehicle && vehicle.tenantId !== consignment?.tenantId;
    if (vehicle && vehicle.id) {
        return (_jsxs("dl", { children: [_jsx("dt", { children: "Registration" }), _jsx("dd", { children: vehicle.registration }), _jsx("dt", { children: "Type" }), _jsx("dd", { children: vehicle.type ? vehicle.type.description : "" }), isContracted ? _jsx("dt", { children: "Partner" }) : null, isContracted ? _jsx("dd", { children: vehicle.tenantName }) : null] }));
    }
    else {
        return _jsx("p", { children: "No Vehicle" });
    }
};
export default ConsignmentAssignedVehicleDefinitionList;
